import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { InfoSheetPanel, Row, Button } from '@fs/zion-ui'
import LinkNamesPanelContent from './components/LinkNamesPanelContent'
import { FORM_ID } from './utils/formDefaults'

const LinkNamesPanel = ({
  title,
  subtitle,
  overlay,
  person,
  field,
  onSave = () => {},
  onCancel = () => {},
  linkedPersonIds = null,
  description,
}) => {
  const [t] = useTranslation()

  const handleCancel = useCallback(() => {
    onCancel()
    overlay.close()
  }, [overlay, onCancel])

  return (
    <InfoSheetPanel
      title={title || t('linkNamesPanel.title', 'View Name')}
      subtitle={subtitle || t('linkNamesPanel.subtitle', 'Manage Linked Names on Shared field')}
      headingColor="red"
      footer={
        <Row alignX="end" gutters="md">
          <Button
            data-testid="link-names-panel-back-button"
            linkName="Link Names Panel Back Button"
            emphasis="low"
            onClick={handleCancel}
          >
            {t('linkNamesPanel.cancel.button', 'Cancel')}
          </Button>
          <Button
            data-testid="link-names-panel-update-button"
            linkName="Link Names Panel Update Button"
            emphasis="high"
            form={FORM_ID}
            type="submit"
          >
            {t('linkNamesPanel.update.button', 'Update')}
          </Button>
        </Row>
      }
      {...overlay}
    >
      {/* Only render the content when the panel is open or transitioning to avoid unnecessary calculations */}
      {(overlay?.isOpen || overlay.transitioning) && (
        <LinkNamesPanelContent
          person={person}
          field={field}
          onSave={onSave}
          linkedPersonIds={linkedPersonIds}
          overlay={overlay}
          description={description}
        />
      )}
    </InfoSheetPanel>
  )
}

export default LinkNamesPanel
